var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { ThemeProvider, useTheme } from "../../hooks/useTheme";
import { makeStyles } from "../../styles/index";
import { Check, CheckOutline, CheckedParent } from "../../icons/index";
import { styles as checkBoxStyles } from "../Checkbox/Checkbox";
var useStyles = makeStyles(checkBoxStyles, { name: 'SnTriStateCheckbox' });
var CheckStateList = ['unchecked', 'indeterminate', 'checked'];
/** CheckStateの次の状態を取得する */
var getNextCheckState = function (currentState) {
    return CheckStateList[(CheckStateList.indexOf(currentState) + 1) % CheckStateList.length];
};
export var TriStateCheckbox = React.forwardRef(function (props, ref) {
    var _a;
    var dark = props.dark, light = props.light, value = props.value, _b = props.defaultValue, defaultValue = _b === void 0 ? 'unchecked' : _b, label = props.label, disabled = props.disabled, onChange = props.onChange, onClick = props.onClick, others = __rest(props, ["dark", "light", "value", "defaultValue", "label", "disabled", "onChange", "onClick"]);
    var classes = useStyles(props);
    var theme = useTheme({ dark: dark, light: light });
    var _c = useState(defaultValue), selectedValue = _c[0], setSelectedValue = _c[1];
    var displayValue = value !== null && value !== void 0 ? value : selectedValue;
    var className = classNames(classes.root, classes[theme.type], (_a = {},
        _a[classes.disabled] = disabled,
        _a[classes.checked] = displayValue !== 'unchecked',
        _a));
    var handleClick = function (e) {
        if (disabled) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(getNextCheckState(displayValue));
        setSelectedValue(getNextCheckState(displayValue));
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var Icon = useMemo(function () {
        switch (displayValue) {
            case 'checked':
                return Check;
            case 'unchecked':
                return CheckOutline;
            default:
                return CheckedParent;
        }
    }, [displayValue]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement("div", { className: className, onClick: handleClick },
            React.createElement("div", { className: classes.border },
                React.createElement(Icon, { className: classes.icon }),
                React.createElement("input", __assign({ ref: ref, className: classes.input, role: "checkbox", type: "checkbox", checked: displayValue !== 'unchecked', readOnly // 外側のonClickで値の制御をするためreadOnlyにしておく
                    : true }, others))),
            label && React.createElement("label", { className: classes.label }, label))));
});
